import { render } from "./YoutubeVideos.vue?vue&type=template&id=b0c36a7a&scoped=true"
import script from "./YoutubeVideos.vue?vue&type=script&lang=js"
export * from "./YoutubeVideos.vue?vue&type=script&lang=js"

import "./YoutubeVideos.vue?vue&type=style&index=0&id=b0c36a7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c36a7a"]])

export default __exports__